/**
 * /app/{slug}/support-tickets/new — raise a Contact WorkRight ticket.
 * `?details=` carries the lines a task screen's "Get Help" adds.
 */
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/lib/auth";
import { isHRAdmin } from "@/lib/nav";
import { PageHeader } from "@/components/shared/page-header";
import { SupportTicketForm } from "@/components/support/ticket-form";
import { SupportOnlyAdmins } from "@/components/support/support-only-admins";

const searchSchema = z.object({ details: z.string().max(500).optional() });

export const Route = createFileRoute("/_authgated/app/$tenantSlug/support-tickets/new")({
  validateSearch: searchSchema,
  component: NewSupportTicketPage,
});

function NewSupportTicketPage() {
  const { details } = Route.useSearch();
  const { user } = useAuth();
  if (!isHRAdmin(user?.role)) return <SupportOnlyAdmins />;
  return (
    <>
      <PageHeader title="Raise a Ticket" description="Ask the WorkRight team about how something works, your plan, or something that looks wrong." />
      <SupportTicketForm prefill={details} />
    </>
  );
}
